export default __webpack_public_path__ + "static/media/robot-wizard.d5eef838.svg";